import cxModal from '@/components/cxModal';
import restoreFocus from '../mixins/restoreFocus';
import autoFocus from '../mixins/autoFocus';

export default function createModal({
  id, content
}) {
  return {
    name: `modal-${id}`,
    data() {
      return {
        show: false
      }
    },
    mixins: [restoreFocus, autoFocus],
    mounted() {
      this._runHookFnc('_onMountedFnc');
    },
    beforeDestroy() {
      this._runHookFnc('_onUnmountedFnc');
    },
    methods: {
      _runHookFnc: function(name) {
        typeof this.$options[name] == 'function' 
          && this.$options[name]()
      },
      open: function() {
        this.show = true;
        this._runHookFnc('_onOpenFnc');
        setTimeout(this._af_autoFocus, 0);
      },
      close: function() {
        this.show = false;
        this._runHookFnc('_onCloseFnc');
      },
    },
    render (h) {
      return h(
        cxModal, {
          on: {
            dismiss: this.close
          },
          directives: [
            {
              name: 'show',
              value: this.show
            },
            {
              name: 'trap-focus',
              value: { escFunc: this.close, live: true }
            }
          ],
          scopedSlots: {
            default: function () {
              return h('div', { domProps: {id: `modal_${id}`, innerHTML: content} })
            }
          }
        }
      )
    },
    watch: {
      '$route.path': function() {
        this.close();
      }
    },
    _onOpenFnc: null,
    onOpen(fnc) {
      if (typeof fnc === `function`) {
        this._onOpenFnc = fnc
        return this;
      }
    },
    _onCloseFnc: null,
    onClose(fnc) {
      if (typeof fnc === `function`) {
        this._onCloseFnc = fnc
        return this;
      }
    },
    _onMountedFnc: null,
    onMounted(fnc) {
      if (typeof fnc === `function`) {
        this._onMountedFnc = fnc
        return this;
      }
    },
    _onUnmountedFnc: null,
    onUnmounted(fnc) {
      if (typeof fnc === `function`) {
        this._onUnmountedFnc = fnc
        return this;
      }
    },
    _onRemoveFnc: null,
    onRemove(fnc) {
      if (typeof fnc === `function`) {
        this._onRemoveFnc = fnc
        return this;
      }
    }
  }
}
